const KEY = 'debunked.accessCode';

export function getAccessCode() {
  try {
    return sessionStorage.getItem(KEY) || '';
  } catch {
    return '';
  }
}

export function setAccessCode(code) {
  try {
    sessionStorage.setItem(KEY, code);
  } catch {
    /* sessionStorage unavailable */
  }
}

export function clearAccessCode() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function hasAccessCode() {
  return getAccessCode().length > 0;
}
